// extracted by mini-css-extract-plugin
module.exports = {"root":"RangeSlider_root__dx3gv","activeHandle":"RangeSlider_activeHandle__1dDDr"};